import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconInfo(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM10.5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM10 10a1 1 0 1 0 0 2h1v6a1 1 0 1 0 2 0v-8h-3Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
